import { render, staticRenderFns } from "./CandidateUpdate.vue?vue&type=template&id=aaa3db40&"
import script from "./CandidateUpdate.vue?vue&type=script&lang=js&"
export * from "./CandidateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports